/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import { ON_PROGRESS_DATA,SET_ENABLE_IS_EDIT, LOADER_STATUS,SET_TOTAL_RECORD,ON_NOTIFY, PROFILE_INFO,SET_GSTR3B_SUMMARY,SET_GSTR3B_FILE_DATA,SET_GSTR3B_FILE_DATA_MASTER } from './constants';

// The initial state of the App
export const initialState = {
  progressData: [],
  loaderStatus: false,
  totalRecord:'',
  profileData:[],
  summary:{},
  gstr3bFileData:[],
  masterData:[],
  status: false,
  msg: '',
  enableIsEdit:0
};

/* eslint-disable default-case, no-param-reassign */
const gstr3bProgressReducer = (state = initialState, action) =>{
    switch (action.type) {
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
        case SET_ENABLE_IS_EDIT:
          return {
            ...state,
            enableIsEdit:action.enableIsEdit
          }
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          totalRecord:action.totalRecord
        }
      case PROFILE_INFO:
        return {
          ...state,
          profileData:action.profileData
        }
      case SET_GSTR3B_SUMMARY:
        return {
          ...state,
          summary:action.gstr3bSummary
        }
      case SET_GSTR3B_FILE_DATA:
        return {
          ...state,
          gstr3bFileData:action.gstr3bFileData
        }
      case SET_GSTR3B_FILE_DATA_MASTER:
        return {
          ...state,
          masterData:action.fileDataMaster
        }
        case ON_NOTIFY:
          return {
            ...state,
            status:action.status,
            msg:action.msg
          }
      default:
        return state;
    }
  };

export default gstr3bProgressReducer;
